import { VehicleNotAvailablePageLabels } from 'libs/shared-lib/interfaces';

export const VEHICLE_NOT_AVAILABLE_LABELS_FR: VehicleNotAvailablePageLabels = {
    headline: '',
    copy: 'Le véhicule n’a pas été trouvé',
    ctaPostText: 'Autres offres',
};
